module.exports = __webpack_public_path__ + "assets/12f07ef63bac47cf1bc44abacdcdf96b.mp4";